<div
  (click)="!isAvailable() ? null : addToCart()"
  class="h-full transition-transform duration-100 active:scale-105"
  [style.backgroundColor]="_cardColor() || '#ffffff'"
>
  <div class="relative flex h-full w-full flex-col justify-between gap-2">
    @if (isShowProductIcon() && (product().description?.length || product().allergens?.length)) {
      <i
        (click)="!isAvailable() ? null : showProductModal(); $event?.stopPropagation?.()"
        class="icon icon-c-info-3 pointer-events-auto absolute right-0 top-0 z-10 content-center pb-3 pl-3 text-center text-xl font-semibold"
        [style.color]="textColor() | contentBuilderColor"
        [class.opacity-50]="!isAvailable()"
      ></i>
    }
    <p
      class="mr-9 line-clamp-2 break-words font-accent text-lg font-bold xl:text-md kiosk-xl:text-xl"
      [style.color]="textColor() | contentBuilderColor"
    >
      {{ product()[ProductKeys.Name] }}
    </p>
    <div class="relative flex w-full flex-row gap-2">
      <div class="flex h-full min-h-24 w-full flex-col justify-between">
        <p
          class="line-clamp-5 break-words text-left font-base text-xs leading-tight kiosk-xl:line-clamp-4 kiosk-xl:text-base"
          [style.color]="textColor() | contentBuilderColor"
        >
          {{ product()[ProductKeys.Description] | firstLine }}
        </p>
        <div class="self-start">
          @if (!product()[ProductKeys.PriceToDisplay]) {
            <div
              class="mt-2 flex flex-row gap-2 text-base xl:mt-3 xl:text-md items-center"
              [style.color]="textColor() | contentBuilderColor"
            >
              @if (displayDiscount()) {
                <app-price-atom
                  class="mr-1"
                  [priceColor]="priceColor()"
                  [amount]="product()[ProductKeys.Discount] ?? 0"
                  [bold]="true"
                ></app-price-atom>
                @if (product()[ProductKeys.Price]) {
                  <app-tag-atom
                    class="mr-1"
                    color="success"
                    text="-{{ discountPercentage() }}%"
                  ></app-tag-atom>
                }
                @if (product()[ProductKeys.Price]) {
                  <app-price-atom
                    class="mr-1"
                    [priceColor]="priceColor()"
                    [amount]="product()[ProductKeys.Price]"
                    [discount]="true"
                    [bold]="true"
                  ></app-price-atom>
                }
              } @else {
                <app-price-atom
                  class="mr-1"
                  [priceColor]="priceColor()"
                  [amount]="product()[ProductKeys.Price]"
                  [discount]="_hasDiscountPromotionLabel()"
                  [bold]="true"
                ></app-price-atom>
              }
              @let visibleLabels = product().labels | appVisibleLabels;
              @if (visibleLabels?.length) {
                <ul class="flex flex-wrap gap-1">
                  @for (label of visibleLabels; track label) {
                    <li>
                      <app-tag-atom
                        [bold]="false"
                        [text]="label.name"
                        [color]="'highlight'"
                        [lineThrough]="label.line_through"
                      ></app-tag-atom>
                    </li>
                  }
                </ul>
              }
            </div>
          }
          @if (product()[ProductKeys.PriceToDisplay]) {
            <div class="mt-2 text-base xl:mt-3 xl:text-md">
              <span class="mr-1"> {{ product()[ProductKeys.PriceToDisplay] }}</span>
            </div>
          }
        </div>
      </div>
      <div
        class="relative flex min-h-24 w-16 min-w-16 items-end overflow-hidden rounded-lg object-cover kiosk-xl:w-28 kiosk-xl:min-w-28"
      >
        @if (quantity()) {
          <div
            class="absolute bottom-0 right-0 z-40 flex h-6 w-6 items-center justify-center rounded-full bg-neutral-300 text-center text-sm font-bold"
          >
            {{ quantity() }}
          </div>
        }

        <div
          class="absolute bottom-0 h-16 w-full rounded-lg kiosk-xl:h-28"
          [appRadialGradient]="product()[ProductKeys.Images]?.thumbnail?.colors"
        ></div>
        @if (product().images?.thumbnail?.url) {
          <img
            class="relative z-10 rounded-lg object-cover"
            [src]="product().images?.thumbnail?.url"
            [alt]="product()[ProductKeys.Name]"
          />
        }
      </div>
    </div>
  </div>
</div>

<!-- Unavailable Overlay -->
@if (!isProductAvailable()) {
  <div
    class="absolute top-0 flex h-full w-full flex-row flex-wrap items-center justify-center gap-5"
  >
    <div class="z-30">
      <app-button-atom
        size="S"
        [label]="'_.UNAVAILABLE' | translate"
        thickSize="XS"
        [overrideBgColor]="unavailableButtonBackground()"
        [overrideTextColor]="unavailableButtonText()"
        type="kiosk-primary"
        [full]="true"
      ></app-button-atom>
    </div>
    <div
      class="unavailable-container pointer-events-none absolute z-20 h-full w-full opacity-80 unavailable-background"
      [class.bg-neutral-400]="!isProductAvailable()"
    ></div>
  </div>
}
